import { createApi } from "@reduxjs/toolkit/query/react";
import { buildBaseQuery } from "@app/api";
import { FilterParams } from "types";

import { IMarket, MarketCreationPayload } from "../types/index";

export const marketApi = createApi({
  reducerPath: "marketApi",
  baseQuery: buildBaseQuery(""),
  endpoints: (builder) => ({
    getMarkets: builder.query<{ markets: IMarket[]; count: number}, FilterParams>({
      query: (params) => {
        const queryString = Object.entries(params)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');

        return `/markets/dashboard?${queryString}`;
      },
    }),
    getMarketById: builder.query<IMarket, string>({
      query: (markId) => `/markets/${markId}`,
    }),
    createMarket: builder.mutation<void, MarketCreationPayload>({
      query: (body) => ({
        url: "/markets",
        method: "POST",
        body,
      }),
    }),
    sortMarkets: builder.mutation<void, { list: { id: string; index: number }[] }>({
      query: (body) => ({
        url: "/markets/sort",
        method: "POST",
        body,
      }),
    }),
    updateMarket: builder.mutation<void, {id: string; body: MarketCreationPayload}>({
      query: ({ id, body }) => ({
        url: `/markets/${id}`,
        method: "PATCH",
        body,
      }),
    }),
    updateMarketConfiguration: builder.mutation<void, {
      id: string;
      body: {
        bestSeller?: boolean;
        activeInHome?: boolean;
      };
    }>({
      query: ({ id, body }) => ({
        url: `/markets/${id}/config`,
        method: "PATCH",
        body,
      }),
    }),
    deleteMarket: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/markets/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetMarketsQuery,
  useLazyGetMarketsQuery,
  useSortMarketsMutation,
  useDeleteMarketMutation,
  useCreateMarketMutation,
  useUpdateMarketMutation,
  useUpdateMarketConfigurationMutation,
  useLazyGetMarketByIdQuery,
} = marketApi;
